export default "__VITE_ASSET__4c9e7f17__"